import './login.scss';
import _ from 'lodash'
import { get } from 'lodash';
import { FORM_ERROR } from 'final-form';
import { race } from 'rxjs';
import { first, map, mapTo } from 'rxjs/operators';
import { Component } from 'vue-property-decorator';

import { User } from '@skinsoft/types'
import { userSelectors } from '@skinsoft/selectors';
import { AuthService } from '@skinsoft/auth';
import { fetch } from '@skinsoft/network';
import { fetchAllLocales } from '@skinsoft/i18n/src/fetch-locale';
import { InstitutionDataStore, TranslationDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { LoginForm } from '../login-form';

@Component({
    components: {
        sLoginForm: LoginForm,
    },
    props: ['homeRoute'],
    template: require('./login.html'),
})
export class Login extends ReactiveVue {
    public $authService: AuthService;

    private homeRoute: string;
    private $institutionDataStore: InstitutionDataStore;

    public created() {
        this.subscribeTo(this.$authService.user$, this.onUser);
    }

    public async onSubmit(values: Record<'username' | 'password', string>) {
        await this.$authService.logIn(values.username, values.password);

        const success$ = this.$authService.waitFor$('authenticated').pipe(mapTo(null));
        const error$ = this.$authService.waitFor$('unauthenticated').pipe(
            map(value => {
                const [, event] = value;
                const error = get(event, 'query.error', null);

                if (!error) {
                    return null;
                }

                return {
                    [FORM_ERROR]: fetch.isNetworkError(error)
                        ? 'auth.login.error.network'
                        : 'auth.login.error.credentials',
                };
            }),
        );

        return await race(success$, error$)
            .pipe(first())
            .toPromise();
    }

    private async onUser(user: User | null) {
        if (user) {
            const userLocale = userSelectors.defaultInterfaceLanguage(user);
            fetchAllLocales(Object.keys(this.$i18n.messages)).subscribe()
            this.$root.$i18n.locale = userLocale;
            if(localStorage.getItem('workspace') == null){
                localStorage.setItem('workspace', userSelectors.defaultWorkspace(user).id)
            }
            this.$institutionDataStore.fetchAllByWorkspace(localStorage.getItem('workspace') as string).subscribe(
                institution => {
                    localStorage.setItem('institution', _.get(institution, '_embedded.institution[0].id'));
                    return fetch.api(`/users/token?institutionId=${_.get(institution, '_embedded.institution[0].id')}&workspaceId=${localStorage.getItem('workspace')}`,
                    {
                        method: 'GET',
                    })
                }
            )

            TranslationDataStore.getInstance().getDateFormat().subscribe(dateFormat => {
                if(dateFormat) {
                    // adapt date format to luxon
                    let cleanedDateFormat = dateFormat
                    // @ts-ignore : until update of typescript replaceAll will generate a linting error
                    cleanedDateFormat = dateFormat.replaceAll('m', 'M')
                    // @ts-ignore : until update of typescript replaceAll will generate a linting error
                    cleanedDateFormat = cleanedDateFormat.replaceAll('Y', 'y')
                    // @ts-ignore : until update of typescript replaceAll will generate a linting error
                    cleanedDateFormat = cleanedDateFormat.replaceAll('D', 'd')

                    console.info('Saving date format in local storage: ', cleanedDateFormat)
                    localStorage.setItem('dateFormat', cleanedDateFormat as string)
                } else {
                    console.error('Failed to retrieve date format from server. Date format: ', dateFormat)
                }
            })

            localStorage.setItem('preferredLocale', userLocale);
            this.$router.push({ name: this.homeRoute });
            return;
        }
    }
}
